import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import { ProfileContext } from "../../context/profile";
import {
  accountUpgradeFetcher,
  changePasswordFetcher,
  profileFetcher,
} from "../../api/requests";
import { useToaster } from "../../context/toaster";
import { baseURL } from "../../api/dataFetcher";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const ChangePassword = () => {
  const { profile, updateProfile } = useContext(ProfileContext);
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    new_password1: "",
  });
  const { addMessage } = useToaster();
  const [errors, setErrors] = useState({
    status: false,
    messages: [],
  });
  const [eye, setEye] = useState({
    old: false,
    new: false,
    repeat: false,
  });

  //   const [parsedUser, setParsedUser] = useState();

  //   useEffect(() => {
  //     const user = Cookies.get("vaghfnamaUser");
  //     if (user) {
  //       const parsed = JSON.parse(user);
  //       setParsedUser(parsed);
  //     }
  //   }, []);

  //   useEffect(() => {
  //     if (profile.user) {
  //       setFormData({
  //         first_name:
  //           profile.first_name.substring(0, 4) ===
  //           parsedUser?.username.substring(7)
  //             ? ""
  //             : profile.first_name || "",
  //         last_name: profile.last_name || "",
  //         image: null,
  //         description: profile?.description || "",
  //         sex: profile?.sex || "",
  //         province: profile.province || "",
  //         city: profile?.city || "",
  //         job: profile?.job || "",
  //         education: profile?.education || "",
  //       });
  //     }
  //   }, [profile.user]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.new_password !== formData.new_password1) {
      setErrors({
        status: true,
        messages: ["رمز عبور جدید و تکرار آن یکسان نیستند."],
      });
      showToast("error", "رمز عبور جدید و تکرار آن یکسان نیستند.");
      return;
    }

    const formDataToSubmit = new FormData();

    formDataToSubmit.append("user", profile.user);
    formDataToSubmit.append("old_password", formData.old_password);
    formDataToSubmit.append("new_password", formData.new_password);
    formDataToSubmit.append("new_password1", formData.new_password1);

    try {
      const res = await changePasswordFetcher.put(formDataToSubmit);

      if (res) {
        showToast("success", "اطلاعات شما با موفقیت تغییر یافت.");
        setErrors({ ...errors, messages: [""] });
      }
    } catch (error) {
      console.error("setting error:", error);
      showToast("error", "متاسفانه خطایی رخ داده است.");
      setErrors((prevErrors) => ({
        ...prevErrors,
        status: true,
        messages: Object.values(error.response.data),
      }));
    }
  };

  const handleCancelClick = () => {
    setFormData({
      old_password: "",
      new_password: "",
      new_password1: "",
    });
    setErrors({ ...errors, status: false, messages: [] });
  };

  const handleEyeClick = (type) => {
    type === "old" && setEye({ ...eye, old: !eye.old });
    type === "new" && setEye({ ...eye, new: !eye.new });
    type === "repeat" && setEye({ ...eye, repeat: !eye.repeat });
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          // maxWidth: "1500px",
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper heading="تغییر رمز عبور" />
              </div>
            </Col>
          </Row>
          <Form onSubmit={handleSubmit}>
            <Form.Row>
              <Form.Group as={Col} controlId="old_password">
                <Form.Label>رمز عبور فعلی</Form.Label>
                <Form.Control
                  type={eye.old ? "text" : "password"}
                  placeholder=""
                  value={formData.old_password}
                  onChange={handleChange}
                  style={{ width: "50%" }}
                />
                <FontAwesomeIcon
                  width={12}
                  height={12}
                  icon={faEye}
                  style={{
                    position: "absolute",
                    top: "60%",
                    left: "51%",
                    cursor: "pointer",
                  }}
                  color="#deb887"
                  onClick={() => handleEyeClick("old")}
                />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="new_password">
                <Form.Label>رمز عبور جدید</Form.Label>
                <Form.Control
                  type={eye.new ? "text" : "password"}
                  placeholder=""
                  value={formData.new_password}
                  onChange={handleChange}
                  style={{ width: "50%" }}
                />
                <FontAwesomeIcon
                  width={12}
                  height={12}
                  icon={faEye}
                  style={{
                    position: "absolute",
                    top: "60%",
                    left: "51%",
                    cursor: "pointer",
                  }}
                  color="#deb887"
                  onClick={() => handleEyeClick("new")}
                />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="new_password1">
                <Form.Label>تکرار رمز عبور جدید</Form.Label>
                <Form.Control
                  type={eye.repeat ? "text" : "password"}
                  placeholder=""
                  value={formData.new_password1}
                  onChange={handleChange}
                  style={{ width: "50%" }}
                />
                <FontAwesomeIcon
                  width={12}
                  height={12}
                  icon={faEye}
                  style={{
                    position: "absolute",
                    top: "60%",
                    left: "51%",
                    cursor: "pointer",
                  }}
                  color="#deb887"
                  onClick={() => handleEyeClick("repeat")}
                />
              </Form.Group>
            </Form.Row>

            <Row>
              <Col className="text-right">
                <Button
                  variant="danger"
                  type="button"
                  onClick={handleCancelClick}
                >
                  لغو
                </Button>
                <Button variant="success mr-1" type="submit">
                  ذخیره تغییرات
                </Button>
              </Col>
            </Row>
            {errors.status &&
              errors.messages.map((item, index) => (
                <p key={index} className="text-danger mt-2">
                  {item}
                </p>
              ))}
          </Form>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default ChangePassword;
